/**
 * @voltxampere/ui — PWL Voltage Source (PWL Kaynağı)
 *
 * Closes the second half of the Class B gap from
 * `TRIAGE_LANE4_FINDINGS.md` §2 — schema canonical `pwl-source`
 * had no UI symbol entry, so any preset / stamp / canonical-fixture
 * using it emitted "No symbol registered" and rendered nothing.
 *
 * IEC convention for PWL stimulus: open circle on the standard
 * 40×26 vertical-source viewBox (matching `dc-source` /
 * `ac-source` / `pulse-source` so vertical-rail layouts stay
 * visually aligned), with a stylised piecewise-linear staircase
 * inside the circle to mark the waveform shape.
 *
 * v1 reference: `~/Desktop/VoltXAmpere/src/components/
 * definitions.js:120` `pwl`. v1 ships the same pattern at the
 * larger 80-px sprite scale (circle radius 18 + 5-point staircase
 * at y ≈ ±4); the v3 geometry below shrinks the staircase to fit
 * the 20-px circle radius while keeping the same visual rhythm.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_DETAIL, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT, } from "./constants.js";
export const pwlSource = {
    id: "pwl-source",
    nameTr: "PWL Kaynağı",
    nameEn: "PWL Source",
    // "W" is taken by the wire tool; PWL uses ⇧W instead.
    shortcut: "⇧W",
    category: "source",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 20, y: 3, label: "+", polarity: "out" },
        { x: 20, y: 23, label: "−", polarity: "in" },
    ],
    defaultLabel: "V",
    defaultValue: "PWL",
    renderSVG: () => [
        // Pin leads — top + bottom from circle edge to viewBox edge.
        `<line x1="20" y1="0" x2="20" y2="3" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="20" y1="23" x2="20" y2="26" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        // Body circle (radius 10, center 20,13).
        `<circle cx="20" cy="13" r="10" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        // Piecewise-linear staircase inside the circle. Five
        // breakpoints span x ∈ [13, 27] (inside the radius=10 body)
        // and rise/fall around y=13 to mimic v1's rhythm.
        `<polyline points="13,15 16,11 19,15 22,9 25,13 27,11" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_DETAIL)}" stroke-linecap="round" stroke-linejoin="round"/>`,
    ].join(""),
};
//# sourceMappingURL=pwl-source.js.map